import React, { useState } from "react";
import Homesection3Button from "./Homesection3Button";
import Homesection3Card from "./Homesection3Card";
import Homesection3Card2 from "./Homesection3Card2";
import int1 from "../../../images/homeimage/int1.jpg";
// import int2 from "../../../images/homeimage/int2.jpg"
import int3 from "../../../images/homeimage/int3.jpg";
import int4 from "../../../images/homeimage/int4.jpg";
import int5 from "../../../images/homeimage/int5.jpg";
import int6 from "../../../images/homeimage/int6.jpg";
import int7 from "../../../images/homeimage/int7.jpg";
import ext1 from "../../../images/homeimage/ext1.jpg";
import ext2 from "../../../images/homeimage/ext2.jpg";
import class1 from "../../../images/homeimage/class1.jpg";
import class2 from "../../../images/homeimage/class2.jpg";
import class3 from "../../../images/homeimage/class3.jpg";
import view from "../../../images/homeimage/view.jpeg";
import int9 from "../../../images/homeimage/int 9.jpeg";
import int8 from "../../../images/homeimage/int8.jpeg";
import other from "../../../images/homeimage/other.jpeg"
import other1 from "../../../images/homeimage/other1.jpeg"
import other2 from "../../../images/homeimage/other2.jpeg"
import ext3 from "../../../images/homeimage/ext3.jpeg"
import ext4 from "../../../images/homeimage/ext4.jpeg"
import ext5 from "../../../images/homeimage/ext5.jpeg"
const Homesection3 = () => {
  const [data, setData] = useState("VIEW ALL");

  return (
    <div id="clip">
      <div className="mt-24 bg-gray-50 pt-24 pb-44 lg:mt-44">
        <div className="justify-evenly text-center lg:flex">
          <div className="mt-10 text-blue-900">
            <h1 className="text-3xl font-bold lg:text-4xl">
              {" "}
              A LOT OF{" "}
              <a className="underline decoration-orange-700"> ACTIVITY </a> IN
              OUR SCHOOL
            </h1>
          </div>

          <div className="mt-9 ">
            <Homesection3Button name="VIEW ALL" func={setData} />
            <Homesection3Button name="INTERIOR" func={setData} />
            <Homesection3Button name="EXTERIOR" func={setData} />
            <Homesection3Button name="OTHER" func={setData} />
          </div>
        </div>
        {data === "VIEW ALL" ? (
          <div className=" mt-20 lg:mx-44">
            <div className="justify-evenly w-[90%] mx-auto lg:flex">
              <Homesection3Card
                image={int1}
                // title={"Architecture building"}
              />
              <div className="container -mt-5 w-full lg:h-80 lg:w-96">
                <img
                  className="h-96 w-full lg:h-80 lg:w-full "
                  src={int7}
                  alt=""
                />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black ">
                    {/* Architecture building */}
                  </div>
                </div>
              </div>
              <Homesection3Card
                image={ext1}
                // title={"Architecture building"}
              />
            </div>
            <div className="-mt-16 justify-evenly lg:mt-10 lg:flex w-[90%] mx-auto">
              <Homesection3Card2
                image={ext2}
                // title={"Architecture building"}
              />
              <div className="container mt-24 w-full lg:-mt-14 lg:w-96">
                <img className="w-full lg:w-full" src={view} alt="" />
                <div className="overlay opacity-40 ">
                  <div className="text font-bold text-black">
                    {/* Architecture building */}
                  </div>
                </div>
              </div>

              <Homesection3Card2
                image={class3}
                // title={"Architecture building"}
              />
            </div>
          </div>
        ) : (
          ""
        )}
        {data === "INTERIOR" && (
          <div className=" mt-20 lg:mx-44">
            <div className="justify-evenly lg:flex">
              <Homesection3Card image={int8} title={"Interior"} />
              <div className="container mt-24 w-full lg:-mt-14 lg:w-96">
                <img className="w-full lg:w-full" src={int3} alt="" />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black">Interior</div>
                </div>
              </div>
              <Homesection3Card image={int9} title={"Interior"} />
            </div>
            <div className="-mt-16 justify-evenly lg:mt-10 lg:flex">
              <Homesection3Card2 image={int4} title={"Interior"} />
              <div className="container mt-8 w-full lg:h-80 lg:w-96">
                <img
                  className="h-96 w-full lg:h-80 lg:w-full"
                  src={int5}
                  alt=""
                />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black">Interior</div>
                </div>
              </div>
              <Homesection3Card2 image={int6} title={"Interior"} />
            </div>
          </div>
        )}
        {data === "EXTERIOR" && (
          <div className=" mt-20 lg:mx-44">
            <div className="justify-evenly  lg:flex">
              <Homesection3Card image={ext1} title={"Exterior"} />
              <div className="container mt-24 w-full lg:-mt-14 lg:w-96">
                <img className="w-full lg:w-full" src={ext2} alt="" />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black">Exterior</div>
                </div>
              </div>
              <Homesection3Card
                image=
                 {ext3}
                
                title={"Exterior"}
              />
            </div>
            <div className="-mt-16 justify-evenly lg:mt-10 lg:flex">
              <Homesection3Card2
                image=
                 {ext4}
                
                title={"Exterior"}
              />
              <div className="container mt-8 w-full lg:h-80 lg:w-96">
                <img
                  className="h-96 w-full lg:h-80 lg:w-full"
                  src={ext5}
                  alt=""
                />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black">Exterior</div>
                </div>
              </div>
              <Homesection3Card2
                image={
                  "https://images.unsplash.com/photo-1580582932707-520aed937b7b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1032&q=80"
                }
                title={"Exterior"}
              />
            </div>
          </div>
        )}
        {data === "OTHER" && (
          <div className=" mt-20 lg:mx-44">
            <div className="justify-evenly lg:flex">
              <Homesection3Card image={class1} title={"Other"} />
              <div className="container mt-24 w-full lg:-mt-14 lg:w-96">
                <img className="w-full lg:w-full" src={class2} alt="" />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black">Other</div>
                </div>
              </div>
              <Homesection3Card image={class3} title={"Other"} />
            </div>
            <div className="-mt-16 justify-evenly lg:mt-10 lg:flex">
              <Homesection3Card2
                image={
                 other
                }
                title={"Other"}
              />
              <div className="container mt-8 w-full lg:h-80 lg:w-96">
                <img
                  className="h-96 w-full lg:h-80 lg:w-full"
                  src={other1}
                  alt=""
                />
                <div className="overlay opacity-40">
                  <div className="text font-bold text-black">Other</div>
                </div>
              </div>
              <Homesection3Card2
                image={
                 other2
                }
                title={"Other"}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Homesection3;
// aakhri baar bta rha hu dekh le thik h?....thik h............. ab thik h????haaa udhar use kiya
// toh ab dekho
